import { Stack, Typography } from "@mui/material";
import { useIntl } from "react-intl";
import {
  H1,
  H3,
  SECONDARY_MAIN,
  SUBTITLE,
  TEXT_SECONDARY,
} from "../../../Constants/CommonConstants";
import {
  ACCOUNT_SETTINGS,
  SECURITY_PREFERENCES,
} from "../../../Constants/SecurityPreferencesConstants";
import { ACCOUNT_SETTING_LABEL } from "../../../Constants/MyProfileConstants";

export const SecurityPreferencesHeader = () => {
  const intl = useIntl();
  return (
    <Stack spacing={2}>
      <Typography
        color={TEXT_SECONDARY}
        id={ACCOUNT_SETTING_LABEL}
        variant={SUBTITLE}
      >
        {intl.formatMessage({ id: ACCOUNT_SETTINGS })}
      </Typography>
      <Typography
        component={H1}
        variant={H3}
        color={SECONDARY_MAIN}
        id={SECURITY_PREFERENCES}
      >
        {intl.formatMessage({ id: SECURITY_PREFERENCES })}
      </Typography>
    </Stack>
  );
};
